import React from 'react';
import { enumValue } from '~/util';
import { ServicesContext } from '~/services';
import { Notes } from '../Notes';

interface QualityGapNotesProps {
    entityId: number;
    patientId: number;
}
export function QualityGapNotes({ entityId, patientId }: QualityGapNotesProps) {
    const servicesContext = React.useContext(ServicesContext);

    async function addNote(note: NewNoteType) {
        await servicesContext.patient.updateQualityGap(entityId, patientId, note);
    }

    return (
        <Notes
            addNote={addNote}
            entityId={entityId}
            noteEntity="quality_gap.id"
            noteType={enumValue(['note', 'type', 'Quality Gap Note']) as number}
        />
    );
}
